import React, { useEffect, useState } from "react";
import Stars from "./stars";

const ReviewsSection = (props) => {
    const proReviews = props.reviews || [];
    const [reviews, setReviews] = useState([])

    const getRandomItems = (array, count) => {
        const shuffled = [...array].sort(() => Math.random() - 0.5);
        return shuffled.slice(0, count);
    }

    useEffect(() => {
        const randomReviews = getRandomItems(proReviews, 6);
        setReviews(randomReviews);
    }, [])

    const dumpsterReviews = () => {
        function truncateString (str) {
            if (str.length <= 600) return str;
            return str.slice(0, 600) + '...';
        }

        function getDate (date) {
            const newDate = date?.replace(" ", "T").replace(/T(\d):/, "T0$1:");;
            if (newDate) {
                return new Date(newDate).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric"
                });
            }
            return '';
        }

        return (
            <div className="booking-reviews-container">
                {
                    reviews?.map((review, index) => {
                        return (
                            <div key={index} className="book-review">
                                <div className="book-review-header">
                                    <Stars rate={review.stars} page='profile' showNumber={false} />
                                    <div className="date">{getDate(review.date)}</div>
                                </div>
                                
                                <div className="book-review-title">{review.customer}{(review.place === '' ? '' : ` in ${review.place}`)}</div>
                                <p>{truncateString(review.text)}</p>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    return (
        <div>
            <div class="container">
                <div>
                    <div className="row m-0">
                        <div className="col-12">
                            <div className={`book-form ${props.class || ''}`}>
                                <h3 className="book-form-title">{props.title}</h3>
                                <h4 className="book-form-subtitle">{props.subtitle}</h4>
                                <div className="booking-reviews">
                                    { dumpsterReviews() }
                                </div>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
        </div>
    );
};

export default ReviewsSection;
